import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["dropdown", "button"]

    initialize() {
        this.buttonTarget.addEventListener('focus', this.showDropdown.bind(this));
        this.buttonTarget.addEventListener('focusout', this.hideDropdown.bind(this));
        
        this.dropdownTarget.querySelectorAll('a').forEach(element => {
            element.addEventListener('focusout', this.hideDropdown.bind(this));
        });
        
        this.buttonTarget.addEventListener('mouseenter', this.showDropdown.bind(this));
        this.element.addEventListener('mouseleave', this.hideDropdown.bind(this));
    }

    showDropdown() {
        this.dropdownTarget.classList.remove('invisible');
        this.dropdownTarget.classList.remove('opacity-0');
    }

    hideDropdown() {
        setTimeout(() => {
            if (this.dropdownTarget.contains(document.activeElement)) {
                return;
            }
            this.dropdownTarget.classList.add('invisible');
            this.dropdownTarget.classList.add('opacity-0');
        }, 200)
    }
}